export enum Tab {
  ALL = 'ALL',
  NO_CAR = 'NO_CAR',
  FOR_REVIEW = 'FOR_REVIEW',
  ACTIVE = 'ACTIVE',
  TRANSFERS_WITHOUT_DRIVER = 'TRANSFERS_WITHOUT_DRIVER',
  UNPAID_ONLINE = 'UNPAID_ONLINE',
  MANUAL_INVOICING = 'MANUAL_INVOICING',
}
